// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__VgljC","options":"AnswerScale_options__20jBY","selected":"AnswerScale_selected__1wktk"};